/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                     from 'react';
import PropTypes                 from 'prop-types';
import { ThemeProvider }         from 'styled-components';
import { Header }                from '../../organisms/Header';
import { StyledMainPicturePage } from '../../atoms/StyledMainPicturePage';
import { Footer }                from '../../organisms/Footer';
import { Colours }               from '../../../styles/variables';
import { AvatarFlat }            from '../../atoms/AvatarFlat';
import { Logo }                  from '../../molecules/Logo';
import { StyledContainer }       from '../../atoms/StyledContainer'



/*********************************************************************************
 2. Component
 *********************************************************************************/

const headerTheme = {
    LogoTextColor: Colours.White,
    TabletColor: Colours.White,
    TabletPosition: 'absolute',
    TabletBackground: 'transparent'
};

export const PicturePage = ({ picture, children }) => (
    <StyledContainer>
        <ThemeProvider theme={headerTheme}>
            <Header>
                <Logo>
                    <AvatarFlat/>
                </Logo>
            </Header>
        </ThemeProvider>
        <StyledMainPicturePage background={picture}>{children}</StyledMainPicturePage>
        <Footer/>
    </StyledContainer>
);

PicturePage.propTypes = {
    children: PropTypes.node,
    picture: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/templates/PicturePage/index.js